import { FC } from 'react';

import { Button, Modal } from '@smartshell/ui-kit';

import s from '../ConfirmationModal.module.scss';
import { IConfirmationModalProps } from '../interfaces';

export const DefaultConfirmationModal: FC<IConfirmationModalProps> = ({
  type,
  config,
  onDecline,
  onAccept,
}) => {
  return (
    <Modal onClose={onDecline} rootId="confirm-root">
      <div className={s.container}>
        <header className={s.title}>{config.title}</header>
        {config.dialogData?.length !== 0 && (
          <ul className={s.data}>
            {config.dialogData?.map((item, index) => (
              <li key={index} className={s.item}>
                <span>{item.name}</span>
                <span>{item.time}</span>
              </li>
            ))}
          </ul>
        )}
        {config.message && <span className={s.message}>{config.message}</span>}
        {type === 'confirm' && (
          <div className={s.confirmControls}>
            <Button variant="primary" onClick={onAccept} fullWidth>
              {config.acceptTitle}
            </Button>
            <Button variant="secondary" onClick={onDecline} fullWidth>
              {config.declineTitle}
            </Button>
          </div>
        )}
        {type === 'remove' && (
          <div className={s.controls}>
            <Button
              variant="primary"
              color="red"
              onClick={onAccept}
              fullWidth
              className={s.remove_button}
            >
              {config.acceptTitle}
            </Button>
            <Button variant="secondary" onClick={onDecline} fullWidth>
              {config.declineTitle}
            </Button>
          </div>
        )}
        {type === 'retry' && (
          <Button onClick={onAccept} iconName="RestartIcon" fullWidth>
            {config.acceptTitle}
          </Button>
        )}
        {type === 'notify' && (
          <Button onClick={onAccept} fullWidth>
            {config.acceptTitle}
          </Button>
        )}
      </div>
    </Modal>
  );
};
